<template>
    <button
        class="snoop-button"
        :class="[
            `snoop-button--${theme}`,
            { 'snoop-button--disabled': disabled },
        ]"
        :disabled="disabled"
        v-on="$listeners"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        disabled: { type: Boolean, default: false },
        theme: {
            type: String,
            default: 'primary',
            validator: value => ['primary', 'link'].includes(value),
        },
    },
}
</script>
